import React, { Component } from 'react'
import { connect } from 'react-redux'

import placeholderIcon from '../../../../assets/images/placeholder-icon.svg'
import _ from 'lodash'

class BkFlowRoomDetailsIcons extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

	renderDetailIcons() {
		const {
			roomGroup,
			roomData,
			displayAllIcons
		} = this.props

		let roomTypeIcons = []

		// construct featured amenities icons array
		if (
			roomData &&
			_.get(roomData, 'viewExtensions.roomAmenityIcons') &&
			!_.isEmpty(roomData.viewExtensions.roomAmenityIcons)
		) {
			const roomAmenities = roomData.viewExtensions.roomAmenityIcons

			for (const amenityKey in roomAmenities) {
				const currentAmenity = roomAmenities[amenityKey]

				if (displayAllIcons) {
					roomTypeIcons.push(currentAmenity)
				} else if (!currentAmenity.isFeatured) {
					roomTypeIcons.push(currentAmenity)
				}
			}
		}

		let renderIconData = []

		for (let iconKey in roomTypeIcons) {
			if (roomTypeIcons[iconKey].name && roomTypeIcons[iconKey].path) {
				renderIconData.push(
					<div
						key={ roomTypeIcons[iconKey].name.replace(/\s+/g, '-').toLowerCase() + '-' + roomData.roomTypeCode + '-' + roomGroup }
						className="bk-flow-room__details-icon"
					>
						{ roomTypeIcons[iconKey].path ?
							<div className="bk-flow-room__details-icon-src">
								<img
									className={'u-icon u-icon-' + roomTypeIcons[iconKey].name.replace(/\s+/g, '-').toLowerCase() }
									src={ roomTypeIcons[iconKey].path }
									alt=''
								/>
							</div>
							:
							<div className="bk-flow-room__details-icon-src">
								<img
									className="u-icon u-icon-placeholder"
									src={ placeholderIcon }
									alt=''
								/>
							</div>
						}

						{ roomTypeIcons[iconKey].name && <p className='u-font-small'>{ roomTypeIcons[iconKey].name }</p> }
					</div>
				)
			}
		}

		return renderIconData
	}

	render() {
		let baseClassNames = 'bk-flow-room__details-icons rows'

		if (process.env.REACT_APP_COMPONENT_FEATURED_ICONS_COMPONENT === 'columns') {
			baseClassNames = 'bk-flow-room__details-icons columns'
		}

		return (
			<div className={baseClassNames}>
				{ this.renderDetailIcons() }
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration
	}
}

export default connect(mapStateToProps, null)(BkFlowRoomDetailsIcons)


// WEBPACK FOOTER //
// ./src/components/room/elements/icons/BkFlowRoomDetailsIcons.js